import React from 'react';
import { ButtonContainer, ButtonText, Icon, IconWrapper } from './styles';
import { ICON_POSITION, BUTTON_SIZE, BUTTON_VARIANT } from './types';

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: BUTTON_VARIANT;
  text?: string;
  icon?: JSX.Element;
  iconPosition?: ICON_POSITION;
  size?: BUTTON_SIZE;
}

export const Button = ({
  variant = 'primary',
  text,
  icon,
  iconPosition = 'left',
  size = 'large',
  type = 'button',
  ...btnProps
}: Props) => {
  return (
    <ButtonContainer
      size={size}
      variant={variant}
      iconposition={iconPosition}
      icon={icon}
      text={text}
      type={type}
      {...btnProps}
    >
      {text && <ButtonText>{text}</ButtonText>}
      {icon && (
        <IconWrapper>
          <Icon>{icon}</Icon>
        </IconWrapper>
      )}
    </ButtonContainer>
  );
};
